import React from 'react';
import { motion } from 'framer-motion';
export function StickyHeader() {
  return <motion.header initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} className="fixed top-0 left-0 right-0 z-50 bg-cream/90 backdrop-blur-md border-b border-gold/20 shadow-sm hidden md:block" data-id="element-219">
      <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between" data-id="element-220">
        <div className="flex items-center gap-3" data-id="element-221">
          <img src="https://cdn.magicpatterns.com/uploads/81dbfNW6C6WxGsU82gWpWz/ChatGPT_Image_26_may_2026,_17_06_14.png" alt="RenuevaTE_90 Logo" className="h-12 w-auto object-contain" data-id="element-222" />
          <span className="font-serif font-semibold text-navy text-xl tracking-wide" data-id="element-223">
            RenuevaTE<span className="text-gold" data-id="element-224">_90</span>
          </span>
        </div>

        <a href="#diagnostico" className="bg-gold hover:bg-gold/90 font-semibold px-6 py-2.5 rounded-full transition-colors duration-300 shadow-md flex items-center gap-2 text-[#0D1B3E]" data-id="element-225">
          Comenzar mi transformación
        </a>
      </div>
    </motion.header>;
}